import { useEffect, useState } from "react";

import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";

const cookieStorageKey = "signamining_pool_cookie_ok_v1";

export const CookieBanner = () => {
    const [isVisible, setIsVisible] = useState(false);

    useEffect(() => {
        try {
            setIsVisible(!window.localStorage.getItem(cookieStorageKey));
        } catch (_) {
            setIsVisible(true);
        }
    }, []);

    const accept = () => {
        try {
            window.localStorage.setItem(cookieStorageKey, new Date().toISOString());
        } catch (_) {}
        setIsVisible(false);
    };

    if (!isVisible) return null;

    return (
        <div className="smCookieBanner" role="dialog" aria-label="Cookie-Hinweis">
            <div>
                <Typography component="strong">Cookies & Datenschutz</Typography>
                <Typography component="p">
                    Wir nutzen nur technisch notwendige Speicherung für deine Cookie-Auswahl und App-Funktionen. Keine Werbung, kein Tracking durch diesen Hinweis.
                </Typography>
            </div>
            <div className="smCookieActions">
                <Button className="smMiningButton" variant="contained" onClick={accept}>Verstanden</Button>
                <Button component="a" href="https://signamining.de/?page=datenschutz" target="_blank" rel="noopener" className="smCookieLink">Datenschutz</Button>
            </div>
        </div>
    );
};
